// @flow

import { Colors } from '@zapier/theme';

export const border = `1px solid ${Colors.steel}`;
export const borderRadius = '10px';
